import React, { useState, useEffect } from "react";
import fetchData from "../../services/requester-website";
import parse from "html-react-parser";
import { defaultSettings } from "../../helpers/default-settings";

const HomeTestimonials = (props) => {
  const [data, setData] = useState([]);

  const getData = () => {
    let reqURL = "testimonials";
    let reqOBJ = "";
    fetchData(
      reqURL,
      reqOBJ,
      (data) => {
        data && setData(data?.filter((x) => x?.showOnHome) || []);
      },
      "GET"
    );
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    data &&
    data.length > 0 && (
      <div className="home-testimonials">
        <h2 className="home-title">
          {props?.testimonialsTitle || defaultSettings?.testimonialsTitle}
        </h2>
        <p className="home-sub-title">
          {props?.testimonialsSubTitle || defaultSettings?.testimonialsSubTitle}
        </p>
        <div className="row">
          {data?.map(
            (x, key) =>
              key < 4 && (
                <div key={key} className="col-lg-3">
                  <div className="home-testimonials-wrap">
                    <h3>{x?.title}</h3>
                    <h4>{x?.subTitle}</h4>
                    <div>{parse("" + x?.description + "")}</div>
                  </div>
                </div>
              )
          )}
        </div>
      </div>
    )
  );
};

export default HomeTestimonials;
